/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, HostBinding, ViewEncapsulation } from '@angular/core';
import classNames from 'classnames';
export class InputGroup {
/**
 * 样式前缀
 */
prefixCls = 'ant-input-group';
/**
 * 控件大小。注：标准表单内的输入框大小限制为 `large`。可选 `large` `default` `small`。
 */
size: 'large' | 'default' | 'small' = 'default';
/**
 * 是否用紧凑模式，默认为 false
 */
compact = false;
/**
 * 用户CSS样式
 */
class: string;
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {

    }
/**
 * 样式
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ classes = classNames(this.prefixCls, {
            [`${this.prefixCls}-lg`]: this.size === 'large',
            [`${this.prefixCls}-sm`]: this.size === 'small',
            [`${this.prefixCls}-compact`]: this.compact,
        }, this.class);
        return classes;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-input-group',
    template: `<ng-content></ng-content>`,
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'size': [{ type: Input },],
'compact': [{ type: Input },],
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
};
}

function InputGroup_tsickle_Closure_declarations() {
/** @type {?} */
InputGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputGroup.ctorParameters;
/** @type {?} */
InputGroup.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
InputGroup.prototype.prefixCls;
/**
 * 控件大小。注：标准表单内的输入框大小限制为 `large`。可选 `large` `default` `small`。
 * @type {?}
 */
InputGroup.prototype.size;
/**
 * 是否用紧凑模式，默认为 false
 * @type {?}
 */
InputGroup.prototype.compact;
/**
 * 用户CSS样式
 * @type {?}
 */
InputGroup.prototype.class;
/** @type {?} */
InputGroup.prototype.renderer;
/** @type {?} */
InputGroup.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
